import pluralize from "pluralize";
import {useState} from "react";
import {FiTrash} from "react-icons/fi";

import {DeleteActionDialog} from "@/components/deleteActionDialog/DeleteActionDialog.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {TableCrownButton} from "@/components/tableCrownButton/TableCrownButton.tsx";
import {deleteStatusPageComponents} from "@/pages/statuspages/utils/quickActions.ts";

interface StatusPageComponentsBulkDeleteActionProps {
  selectedItems: Record<string, boolean>;
  statusPageId: number;
  setSelectedItems: (selectedItems: Record<string, boolean>) => void;
}

export const StatusPageComponentsBulkDeleteAction = ({
  selectedItems,
  setSelectedItems,
  statusPageId,
}: StatusPageComponentsBulkDeleteActionProps) => {
  const [showDelete, setShowDelete] = useState<boolean>(false);
  const componentIds = Object.keys(selectedItems);

  return (
    <>
      <TableCrownButton onClick={() => setShowDelete(true)}>
        <Icon icon={FiTrash} />
        Delete
      </TableCrownButton>
      <DeleteActionDialog
        show={showDelete}
        title={`Delete Status Page Components`}
        onConfirm={async () => {
          await deleteStatusPageComponents(
            statusPageId,
            componentIds.map((str) => +str)
          );
          setSelectedItems({});
          setShowDelete(false);
        }}
        onCancel={() => {
          setShowDelete(false);
        }}
      >
        Are you sure you want to delete {componentIds.length} {pluralize("Component", componentIds.length)} ? This will
        affect the Components in any related Incident.
      </DeleteActionDialog>
    </>
  );
};
